import { Link } from "@inertiajs/react"
import { ExternalLink } from "lucide-react"

function BrandLinkBanner({ href, label }) {
    return (
        <Link
            href={href}
            className="inline-flex items-center gap-2 text-[16px] font-medium text-[#151515] transition-colors hover:text-blue-400"
        >
            <span>{label}</span>
            <ExternalLink className="w-4 h-4" />
        </Link>
    )
}

export default function BrandLinksBanner({ brandFacets }) {
    const links = brandFacets?.links

    if (!links?.length) {
        return null
    }

    return (
        <div>
            <h3 className="text-[20px] text-gray-700 lg:text-[22px] mt-[48px] mb-4 font-medium">
                More on FirearmLand
            </h3>
            <div className="flex flex-col items-start gap-3">
                {links.map((link) => (
                    <BrandLinkBanner
                        key={link.href}
                        href={link.href}
                        label={link.label}
                    />
                ))}
            </div>
        </div>
    )
}
